module.exports = {
  printReward: `

  @page {
    size: A4 landscape;
  }
  * {
    box-sizing: border-box;
  }
  table {
    border: 1px solid #CACACA;
    border-collapse: collapse;
  }
  thead tr {
    background-color: rgb(240, 240, 240);
  }
  th {
    padding-inline: .5em;
    height: 40px;
  }
  td {
    border-right: 1px solid #CACACA;
    height: 40px;
    padding-inline: .5em;
  }
  #preview {
    display: flex;
    flex-direction: column;
    gap: 21px;
    background-color: #FFFFFF;
    z-index: 100;
  }
  .titlename {
    color: #5E5E5E;
    font-family: Noto Sans TC;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 4px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }`,
  SubPrintReward: `

  @page {
    size: A4 landscape;
  }
  * {
    box-sizing: border-box;
  }
  table {
    border: 1px solid #CACACA;
    border-collapse: collapse;
  }
  thead tr {
    background-color: rgb(240, 240, 240);
  }
  th {
    padding-inline: .5em;
    height: 40px;
  }
  td {
    border-right: 1px solid #CACACA;
    height: 40px;
    padding-inline: .5em;
  }
  #preview {
    display: flex;
    flex-direction: column;
    gap: 21px;
    background-color: #FFFFFF;
    z-index: 100;
  }
  .titlename {
    color: #5E5E5E;
    font-family: Noto Sans TC;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 4px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }`
}
